import Photo from 'app/models/photo';
import Listable, { IListable } from 'app/mixins/listable';
import { User } from './user';
import MlsTimeline from './mls-timeline';

export interface ListingTimelineField {
  name: string;
  slug: string;
  value: string;
  formatted_value: string;
}

export interface ListingTimelineable {
  id: string;
  name: string;
  street_number: string;
  street_name: string;
  unit_number: string;
  city: string;
  state: string;
  county: string;
  zip_code: string;
  latitude: number;
  longitude: number;
  listing_url: string;
  pin_image_url: string;
  pin_image_filename: string;
  lead_photo_url?: string;
  savings_in_cents?: string;
  timeline_fields: ListingTimelineField[];
  photos: Photo[];
  primary_agent?: User;
}

export class ListingTimeline implements IListable, ListingTimelineable {
  id: string;
  name: string;
  street_number: string;
  street_name: string;
  unit_number: string;
  city: string;
  state: string;
  county: string;
  zip_code: string;
  latitude: number;
  longitude: number;
  listing_url: string;
  pin_image_url: string;
  pin_image_filename: string;
  lead_photo_url?: string;
  savings_in_cents?: string;
  timeline_fields: ListingTimelineField[] = [];
  photos: Photo[] = [];
  primary_agent: User;
  mls_timelines: MlsTimeline[];

  constructor(listingTimelineable?: ListingTimelineable) {
    if (listingTimelineable) Object.assign(this, listingTimelineable);
  }
}

export class ListableListingTimeline extends Listable(ListingTimeline) { }
